/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '',
    // Relative to /src/views
    view: 'Dashboard',
  },
  {
    path: '/login',
    name: 'Login',
    view: 'Login',
  },
  {
    path: '/products',
    name: 'Products',
    view: 'Products',
  },
  {
    path: '/orders',
    name: 'Orders',
    view: 'Orders',
  },
  {
    path: '/collections',
    name: 'collections',
    view: 'Collections',
  },
  {
    path: '/promotions',
    name: 'promotions',
    view: 'Promotions',
  },
  {
    path: '/banners',
    name: 'banners',
    view: 'Banners',
  },
  {
    path: '/categories',
    name: 'Categories',
    view: 'Categories',
  },
  {
    path: '/coupons',
    name: 'Coupons',
    view: 'Coupons',
  },
  {
    path: '/settings',
    name: 'Settings',
    view: 'Settings',
  },
  {
    path: '/settings/shipping',
    name: 'Shipping Settings',
    view: 'Settings/Shipping',
  },
  {
    path: '/settings/policies',
    name: 'Policies Settings',
    view: 'Settings/Policies',
  },
  {
    path: '/categories',
    name: 'categories',
    view: 'Categories',
  },
  {
    path: '/reports',
    name: 'reports',
    view: 'Reports',
  },
  {
    path: '/vendors',
    name: 'vendors',
    view: 'Vendors',
  },
  {
    path: '/admins',
    name: 'admins',
    view: 'Admins',
  },
  {
    path: '/slider',
    name: 'slider',
    view: 'Slider',
  },
  {
    path: '/paymentconfig',
    name: 'paymentconfig',
    view: 'PaymentConfig',
  },
  {
    path: '/executives',
    name: 'executives',
    view: 'DeliveryExecutives',
  },
];
